import * as types from './types';

export const openTermsModal = () => ({
  type: types.TERMS_MODAL_OPEN
});

export const closeTermsModal = () => ({
  type: types.TERMS_MODAL_CLOSE
});
